import { render, staticRenderFns } from "./ListCards.vue?vue&type=template&id=f484e902&scoped=true"
import script from "./ListCards.vue?vue&type=script&lang=ts"
export * from "./ListCards.vue?vue&type=script&lang=ts"
import style0 from "./ListCards.vue?vue&type=style&index=0&id=f484e902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f484e902",
  null
  
)

export default component.exports